export default "__VITE_ASSET__2c337830__"